import React from 'react';
import Input from './Input';
import './InputFile.scss';
import * as api from '../lib/api';
import _ from 'lodash';
import config from '../config';

export default class InputFile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      uploading: false,
      selectedFiles: _.isArray(props.value) ?
          props.value :
          (props.value ? [props.value] : []),
    };
    this.inputFile = React.createRef();
    this.sampleFile = props.sampleFile;
    if(this.sampleFile && !this.sampleFile.includes('//')){
      this.sampleFile = `https://s3-${config.apiGateway.REGION}.amazonaws.com/${config.s3.APP_BUCKET}${this.sampleFile}`;
    }

    this.openFileDialog = this.openFileDialog.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.renderFile = this.renderFile.bind(this);
  }

  isMultiple() {

  }

  openFileDialog() {
    if (this.state.uploading) return;

    this.inputFile.current.click();
  }

  stopPropagation(e) {
    e.preventDefault();
  }

  async handleChange(e) {
    let selectedFiles = Array.from(e.target.files);
    if (_.isEmpty(selectedFiles)) return;

    this.setState({uploading: true});

    let results = await Promise.all(selectedFiles.map((file) => {
      return api.upload(file);
    }));

    results = _.map(results, (result) => {
      return {
        name: result.Name,
        url: result.Location,
      };
    });

    results = (this.state.selectedFiles || []).concat(results);

    this.setState({
      uploading: false,
      selectedFiles: results,
    });

    if (this.props.onChange) {
      this.props.onChange(this.props.multiple ? results : _.first(results));
    }
  }

  handleDeleteFile(index, e) {
    e.stopPropagation();
    let file = this.state.selectedFiles[index];
    if (!window.confirm(`Are you sure you want to remove '${file.name}'?`)) {
      return;
    }

    let newFileSet = this.state.selectedFiles.filter(
        (item, itemIndex) => itemIndex !== index);

    this.setState({
      selectedFiles: newFileSet,
    });

    if (this.props.onChange) {
      this.props.onChange(
          this.props.multiple ? newFileSet : _.first(newFileSet) );
    }
  }

  renderFile(file, index) {
    return (
        <div className="file-box" key={`file-box-${index}`} title={file.name}>
          <button onClick={this.handleDeleteFile.bind(this, index)}>
            <i className="fa fa-trash-alt"></i>
          </button>
          {file.name}
        </div>
    );
  }

  render() {
    return (
        <Input {...this.props} className="ComponentInputFile">
          <div style={{'position': 'relative'}}>
            <input className="field-wrap" placeholder="" type="file"
                   required={this.props.required} tabIndex="2"
                   style={this.props.sampleFile ? {'marginBottom': 0} : null}
                   ref={this.inputFile}
                   multiple={this.props.multiple}
                   onChange={this.handleChange}
            />
            <div className="field-wrap file-container"
                 onClick={this.openFileDialog}
                 style={{
                   ...(!_.isEmpty(this.state.selectedFiles) ?
                       {} :
                       {color: '#aaa'}),
                   ...(_.isEmpty(this.props.sampleFile) ?
                       {} :
                       {marginBottom: 0}),
                 }}
            >
              {!_.isEmpty(this.state.selectedFiles) ?
                  this.state.selectedFiles.map(this.renderFile) :
                  (<span>Browse...</span>)}
              <button onClick={this.stopPropagation}
                      className="btn-select"
                      disabled={this.state.uploading}>{this.state.uploading ?
                  'Uploading...' :
                  'Select file'}</button>
            </div>
            {this.sampleFile ? (
                <div className="Download-here">
                  <a href={this.sampleFile} target="_blank"><i>* Download
                    sample file from
                    here</i></a>
                </div>
            ) : ''}
          </div>
        </Input>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/InputFile.js